import { collection, doc, setDoc } from "firebase/firestore";
import { db } from "..";
import { Message_Type } from "../../model";

const collection_name = "messages";

export const collectionREf = collection(db, collection_name);

export const setMessageData = async (message: Message_Type) => {
  try {
    await setDoc(doc(collectionREf, message.id), message);
  } catch (error) {
    console.log("Error in setMessage", error);
  }
};
